import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import AppContext from "../AppContext";

interface MicrosoftAuthStatusProps {}

interface MicrosoftAuthStatusState {
  authMethod: string;
  microsoftUserInfo: any;
}

class MicrosoftAuthStatus extends React.Component<MicrosoftAuthStatusProps, MicrosoftAuthStatusState> {
  static contextType = AppContext;

  constructor(props: MicrosoftAuthStatusProps) {
    super(props);
    this.state = {
      authMethod: "",
      microsoftUserInfo: null
    };
  }

  componentDidMount() {
    // Safely access context methods
    try {
      const authMethod = this.context?.getAuthMethod?.() || "";
      const microsoftUserInfo = this.context?.getMicrosoftUserInfo?.() || null;
      
      this.setState({
        authMethod,
        microsoftUserInfo
      });
    } catch (error) {
      console.warn("MicrosoftAuthStatus: Context methods not available:", error);
    }
  }

  render() {
    const { authMethod, microsoftUserInfo } = this.state;

    // Don't render anything if not Microsoft auth or no user info
    if (authMethod !== "microsoft" || !microsoftUserInfo) {
      return null;
    }

    try {
      return (
        <div style={{ 
          padding: "10px", 
          margin: "10px 0", 
          backgroundColor: "#e3f2fd", 
          border: "1px solid #2196f3", 
          borderRadius: "5px",
          fontSize: "12px"
        }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
            <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: "8px", color: "#0078d4" }} />
            <strong>Microsoft SSO Active</strong>
          </div>
          <div style={{ color: "#666" }}>
            <strong>User:</strong> {microsoftUserInfo.displayName || "Unknown"}
          </div>
          <div style={{ color: "#666" }}>
            <strong>Email:</strong> {microsoftUserInfo.mail || microsoftUserInfo.userPrincipalName || "Unknown"}
          </div>
          {microsoftUserInfo.jobTitle && (
            <div style={{ color: "#666" }}>
              <strong>Title:</strong> {microsoftUserInfo.jobTitle}
            </div>
          )}
        </div>
      );
    } catch (error) {
      console.error("MicrosoftAuthStatus render error:", error);
      return null;
    }
  }
}

export default MicrosoftAuthStatus;
